"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ramda_1 = require("ramda");
const round = (value, precision = 0) => ramda_1.compose(value => value.toFixed(precision), value => +(`${value[0]}e${value[1] ? (+value[1] - precision) : -precision}`), ramda_1.split("e"), ramda_1.toString, value => Math.round(+(`${value[0]}e${value[1] ? (+value[1] + precision) : precision}`)), ramda_1.split("e"), ramda_1.toString)(value);
exports.default = round;
